export default __webpack_public_path__ + "static/Light-Demolition-b4ba439455ead727a705024dbda567ad.jpg";